"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "throttle", {
  enumerable: true,
  get: function get() {
    return _debouncer["default"];
  }
});
exports.text = exports.spy = exports.scroll = exports.router = exports.forms = exports.events = void 0;

var events = _interopRequireWildcard(require("./custom-events"));

exports.events = events;

var _debouncer = _interopRequireDefault(require("./debouncer"));

var forms = _interopRequireWildcard(require("./forms"));

exports.forms = forms;

var router = _interopRequireWildcard(require("./router"));

exports.router = router;

var scroll = _interopRequireWildcard(require("./scroll"));

exports.scroll = scroll;

var spy = _interopRequireWildcard(require("./spy"));

exports.spy = spy;

var text = _interopRequireWildcard(require("./text"));

exports.text = text;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }